import styled from "styled-components";

import { ReactComponent as SvgDots } from "../../assets/dots.svg";

export const Container = styled.div<{ isFocused: boolean; isSection: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ isSection }) => (isSection ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.1)")};
`;

export const Section = styled.div<{ isFocused: boolean }>`
  left: 300;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  width: 100%;
  padding: 24px;
  padding-bottom: ${({ isFocused }) => (isFocused ? 0 : null)};
  box-sizing: border-box;
`;

export const Card = styled.div<{ isFocused: boolean; isTitle: boolean }>`
  display: flex;
  flex-direction: column;
  border: ${({ theme, isFocused }) =>
    `${isFocused ? "2px" : "1px"} solid ${
      isFocused ? theme.colors.BLUE_HEAVY : theme.colors.GREY_HEAVY
    }`};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  min-height: 138px;
  width: 100%;
  padding: 24px;
  padding-bottom: ${({ isFocused, isTitle }) => (isFocused && !isTitle ? 0 : null)};
  box-sizing: border-box;
`;

export const ClickHighlight = styled.div<{ isFocused: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  // background-color: ${({ theme, isFocused }) => (isFocused ? theme.colors.BLUE_HEAVY : "")};
  min-height: 100%;
  width: 6px;
  z-index: 10;
`;

export const CardDndHandle = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  width: 100%;
  height: 30px;
  z-index: 20;

  :hover {
    > :last-child {
      visibility: visible;
    }
  }
`;

export const Dots = styled(SvgDots)`
  visibility: hidden;
  position: absolute;
  left: calc(50% - 10px);
  width: 20px;
  z-index: 30;
`;

export const FileTypeSection = styled.img`
  width: 30px;
  height: 30px;
  object-fit: cover;
  margin: 10px;
`;

export const RequireMark = styled.span`
  padding-left: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.RED};
`;
